//*  topcg/scr/store.js
//*      Establece la inicialización con Firebase y el almacen con las variables globales.
//*
//*
//*
//*      Muestra el menú de opciones    
//*======================================================================================================== */

import Vue from 'vue';
import Vuex from 'vuex';

import {
     db,
     rutaEvalTipolo, rutaEvalFactor, rutaEvalEstabi, rutaEvalSociab,
     rutaEvalPerfil, rutaEvalSuperv, rutaEvalApvtas, rutaEvalEmoc,
     rutaEvalSolemp, rutaEvalVtas2, rutaEvalAuxi, rutaEvalAEDP,
     rutaUsuarios, rutaCV,
     dbEvalTipolo, dbEvalFactor, dbEvalEstabi, dbEvalSociab,
     dbEvalPerfil, dbEvalSuperv, dbEvalApvtas, dbEvalEmoc,
     dbEvalSolemp, dbEvalVtas2, dbEvalAuxi, dbEvalAEDP,
     dbUsuarios, dbCV,
     stg,
     rutaCVs, rutaFotosU,
     stgCVs, stgFotosU,
} from './myFirebaseApp'

// import deptos from './modules/deptos.js'

import { getters } from './getters'
import { mutations } from './mutations';

Vue.use(Vuex);

/* Exportamos a través de la constante STORE los valores de la base de datos (db) 
   la ruta, path o nodo a acceder */
export const store = new Vuex.Store({

     // modules: {
     //      deptos,
     // },
     state: {
          auth: true,
          
          //** Obtiene el path del nodo de las evaluaciones y usuarios, 
          //*  así como la referencia para su acceso (st_dbxyz) 
          st_db:             db,
          st_rutaEvalTipolo: rutaEvalTipolo,
          st_rutaEvalFactor: rutaEvalFactor,
          st_rutaEvalEstabi: rutaEvalEstabi,
          st_rutaEvalSociab: rutaEvalSociab,
          st_rutaEvalPerfil: rutaEvalPerfil,
          st_rutaEvalSuperv: rutaEvalSuperv,
          st_rutaEvalApvtas: rutaEvalApvtas,
          st_rutaEvalSolemp: rutaEvalSolemp,
          st_rutaEvalEmoc:   rutaEvalEmoc,
          st_rutaEvalVta2s:  rutaEvalVtas2,
          st_rutaEvalAuxi:   rutaEvalAuxi,
          st_rutaEvalAEDP:   rutaEvalAEDP,

          st_rutaUsuarios: rutaUsuarios,
          st_rutaCVs: rutaCV,

          st_dbEvalTipolo: dbEvalTipolo,
          st_dbEvalFactor: dbEvalFactor,
          st_dbEvalEstabi: dbEvalEstabi,
          st_dbEvalSociab: dbEvalSociab,
          st_dbEvalPerfil: dbEvalPerfil,
          st_dbEvalSuperv: dbEvalSuperv,
          st_dbEvalApvtas: dbEvalApvtas,
          st_dbEvalSolemp: dbEvalSolemp,
          st_dbEvalEmoc:   dbEvalEmoc,
          st_dbEvalVtas2:  dbEvalVtas2,
          st_dbEvalAuxi:   dbEvalAuxi,
          st_dbEvalAEDP:   dbEvalAEDP,

          st_dbUsuarios: dbUsuarios,
          st_dbCVs:      dbCV,

          //** Obtiene el path de la carpeta de los CVs y Fotos de usuarios
          //*  así como la referencia para su acceso (st_sthxyz) 
          st_stg:         stg,
          st_rutaCVs:     rutaCVs,
          st_rutaFotosU:  rutaFotosU,

          st_stgCVs:     stgCVs,
          st_stgFotosU:  stgFotosU,

          //** Datos del usuario en sesión */
          st_logeado: false,       //* Está logeado
          st_usuario: "",          //* Almacena la UID del usuario
          st_clave: "",            //* Clave del usuario
          st_email: "",            //* Email
          st_nusuario: "",         //* Nombre del usuario
          st_usuarios: [],         //* Objeto con el nodo de los usuarios
          st_roles: "",            //* Roles del usuario en sesión
          st_activo: "",           //* Está activo el usuario ?
          st_admin: false,         //* Si es Administrador.
          st_empresa: "",          //* Nombre de la empresa a la que pertenece el usuario.
          st_llave: "",

          st_modo: "INGRESO",  // Por default es ingreso porque es la primera vista que tendrá el usuario

          //** Variables para el pagineo de registros */
          pagina: 1,
          lini: 0, lfin: 5, limite: 5, diferencia: 5,
          esLimiteSup: false, esLimiteInf: true,

          st_eval: [],

          //* Limites inicial y final para los Casos */
          Cpagina: 1, Clini: 0, Clfin: 5, CesLimiteSup: false, CesLimiteInf: true,

          //* Limites inicial y final para los Departamentos */
          Dpagina: 1, Dlini: 0, Dlfin: 5, DesLimiteSup: false, DesLimiteInf: true,

          //* Variables para un nuevo caso o el caso concurrente en la lista de casos. Funcionará para ON-LINE y OFF-LINE */
          st_ev01: {
               depto: "Guatemala",
               empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
               fecha: "16/01/2019", sexo: "",
               empezo: "10am", termino: "12am",
               pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
               pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
               pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
               pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
               pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, pg046: 0, pg047: 0, pg048: 0, pg049: 0, pg050: 0,
               pg051: 0, pg052: 0, pg053: 0, pg054: 0, pg055: 0, pg056: 0, pg057: 0, pg058: 0, pg059: 0, pg060: 0,
               pg061: 0, pg062: 0, pg063: 0, pg064: 0, pg065: 0, pg066: 0, pg067: 0, pg068: 0, pg069: 0, pg070: 0,
          },
          st_rs01: {
               a1: 0, b2: 0, a5: 0, b6: 0, a9: 0, b10: 0, a3: 0, b4: 0, a7: 0, b8: 0, a11: 0, b12: 0,
               E: 0, I: 0, S: 0, N: 0, T: 0, F: 0, J: 0, P: 0,
               par1iguales: false, par2iguales: false, par3iguales: false, par4iguales: false,
               topologia: "",
               topologiaEI1: "", topologiaSN1: "", topologiaTF1: "", topologiaJP1: "",
               topologia1: "", topologia2: "", topologia3: "", topologia4: "", topologia5: "",
               topologia6: "", topologia7: "", topologia8: "", topologia9: "", topologia10: "",
               topologia11: "", topologia12: "", topologia13: "", topologia14: "", topologia15: "",
               topologia16: "",
          },

          //* Variables para FACTORES DE PERSONALIDAD (16PF), 40 PREGUNTAS */
          st_ev02: {
               depto: "Guatemala",
               empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
               fecha: "16/01/2019", sexo: "",
               empezo: "10am", termino: "12am",
               pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
               pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
               pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
               pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
               pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, pg046: 0, pg047: 0, pg048: 0, pg049: 0, pg050: 0,
               pg051: 0, pg052: 0, pg053: 0, pg054: 0, pg055: 0, pg056: 0, pg057: 0, pg058: 0, pg059: 0, pg060: 0,
               pg061: 0, pg062: 0, pg063: 0, pg064: 0, pg065: 0, pg066: 0, pg067: 0, pg068: 0, pg069: 0, pg070: 0,
               pg071: 0, pg072: 0, pg073: 0, pg074: 0, pg075: 0, pg076: 0, pg077: 0, pg078: 0, pg079: 0, pg080: 0,
               pg081: 0, pg082: 0, pg083: 0, pg084: 0, pg085: 0, pg086: 0, pg087: 0, pg088: 0, pg089: 0, pg090: 0,
               pg091: 0, pg092: 0, pg093: 0, pg094: 0, pg095: 0, pg096: 0, pg097: 0, pg098: 0, pg099: 0, pg100: 0,
               pg101: 0, pg102: 0,
          },
          st_rs02: {
               resA: 0, resP: 0, resA: 0, resB: 0, resC: 0, resE: 0, resF: 0, resG: 0, resH: 0,
               resI: 0, resL: 0, resM: 0, resN: 0, resO: 0, resQ1: 0, resQ2: 0, resQ3: 0, resQ4: 0,
               rangoP: 0, rangoA: 0, rangoB: 0, rangoC: 0, rangoE: 0, rangoF: 0, rangoG: 0, rangoH: 0,
               rangoI: 0, rangoL: 0, rangoM: 0, rangoN: 0, rangoO: 0, rangoQ1: 0, rangoQ2: 0, rangoQ3: 0, rangoQ4: 0,
          },
          //* Variables para ESTABILIDAD (NPF), 40 PREGUNTAS */
          st_ev03: {
               depto: "Guatemala",
               empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
               fecha: "16/01/2019", sexo: "",
               empezo: "10am", termino: "12am",
               pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
               pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
               pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
               pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
          },
          st_rs03: {
               Uno: 0, Dos: 0, Cero: 0, Uno2: 0, Dos2: 0, Cero2: 0,
               cpreviaIzq: 0, cpreviaDer: 0,
               rangos: 0,
          },
          //* Variables para SOCIABILIDAD (CPF), 40 PREGUNTAS */
          st_ev04: {
               depto: "Guatemala",
               empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
               fecha: "16/01/2019", sexo: "",
               empezo: "10am", termino: "12am",
               pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
               pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
               pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
               pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
          },
          st_rs04: {
               Uno: 0, Dos: 0, Cero: 0, Uno2: 0, Dos2: 0, Cero2: 0,
               cpreviaIzq: 0, cpreviaDer: 0,
               rangos: 0,
          },
          //* Variables para PERFIL DE PERSONALIDAD, 48 PREGUNTAS */
          st_ev05: {
               depto: "Guatemala",
               empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
               fecha: "16/01/2019", sexo: "",
               empezo: "10am", termino: "12am",
               pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
               pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
               pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
               pg031: "", pg032: "", pg033: "", pg034: "", pg035: "", pg036: "", pg037: "", pg038: "", pg039: "", pg040: "",
               pg041: "", pg042: "", pg043: "", pg044: "", pg045: "", pg046: "", pg047: "", pg048: "",
          },
          st_rs05: {
               mas_D: 0, menos_D: 0, mas_I: 0, menos_I: 0, mas_S: 0, menos_S: 0,
               mas_C: 0, menos_C: 0, mas_N: 0, menos_N: 0, mas_W: 0, menos_W: 0,
               total_mas: 0, total_menos: 0,
          },
          //* Variables para PERFIL DE PERSONALIDAD, 48 PREGUNTAS */
          st_ev06: {
               depto: "Guatemala",
               empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
               fecha: "16/01/2019", sexo: "",
               empezo: "10am", termino: "12am",
               pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
               pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
               pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
          },
          st_rs06: {
               hs: 0, cd: 0, ce: 0, hr: 0, sc: 0,
               aciertos: 0,
               percentilHS: 0, rangoHS: "",
          },
          st_ev07: {
               depto: "Guatemala",
               empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
               fecha: "16/01/2019", sexo: "",
               empezo: "10am", termino: "12am",
               pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
               pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
               pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
          },
          st_rs07: {
               rango: 0, resta: 0, 
               aciertos: 0, errores: 0,
               genero: "",
          },
          st_ev08: {
               depto: "Guatemala",
               empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
               fecha: "16/02/2019", sexo: "",
               empezo: "10am", termino: "12am",
               pg001: "", pg002: "", pg003: new Date(), pg004: 0, pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
               pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
               pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
               pg031: "", pg032: "", pg033: "", pg034: "", pg035: "", pg036: "", pg037: "", pg038: "", pg039: "", pg040: "",
               pg041: "", pg042: "", pg043: "", pg044: "", pg045: "", pg046: "", pg047: "", pg048: "", pg049: "", pg050: "",
               pg051: "", pg052: "", pg053: "", pg054: "", pg055: "", pg056: "", pg057: "", pg058: "", pg059: "", pg060: "",
               pg061: "", pg062: "", pg063: "", pg064: "", pg065: "", pg066: "", pg067: "", pg068: "", pg069: "", pg070: "",
               pg071: "", pg072: "", pg073: "", pg074: "", pg075: "", pg076: "", pg077: "", pg078: "", pg079: "", pg080: "",
               pg081: "", pg082: "", pg083: "", pg084: "", pg085: "", pg086: "", pg087: "", pg088: "", pg089: "", pg090: "",
               pg091: "", pg092: "", pg093: "", pg094: "", pg095: "", pg096: "", pg097: "", pg098: "", pg099: "", pg100: "",
               pg101: "", pg102: "", pg103: "", pg104: "", pg105: "", pg106: "", pg107: "", pg108: "", pg109: "", pg110: "",
               pg111: "", pg112: "", pg113: "", pg114: "", pg115: "", pg116: "", pg117: "", pg118: "", pg119: "", pg120: "",
               pg121: "", pg122: "", pg123: "", pg124: "", pg125: "", pg126: "", pg127: "", pg128: "", pg129: "", pg130: "",
               pg131: "", pg132: "", pg133: "", pg134: "", pg135: "", pg136: "", pg137: "", pg138: "", pg139: "", pg140: "",
               pg141: "", pg142: "", pg143: "", pg144: "", pg145: "", pg146: "", pg147: "", pg148: "", pg149: "", pg150: "",
               pg151: "", pg152: "", pg153: "", pg154: "", pg155: "", pg156: "", pg157: "", pg158: "", pg159: "", pg160: "",
               pg161: "", pg162: "", pg163: "", pg164: "", pg165: "", pg166: "", pg167: "", pg168: "", pg169: "", pg170: "",
               pg171: "", pg172: "", pg173: "", pg174: "", pg175: "", pg176: "", pg177: "", pg178: "", pg179: "", pg180: "",
               pg181: "", pg182: "", pg183: "", pg184: "", pg185: "", pg186: "", pg187: "", pg188: "", pg189: "", pg190: "",
               pg191: "", pg192: "", pg193: "", pg194: "", pg195: "", pg196: "", pg197: "", pg198: "", pg199: "", pg200: "",
               pg201: "", pg202: "", pg203: "", pg204: "", pg205: "", pg206: "", pg207: "", 
          },
          st_rs08: {
               rango: 0, resta: 0,
               aciertos: 0, errores: 0,
               genero: "",
          },
          st_ev09: {
               depto: "Guatemala",
               empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
               fecha: "16/02/2019", sexo: "",
               empezo: "10am", termino: "12am",
               pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
               pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
               pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
               pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
               pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, 
          },
          st_rs09: {
               autocon_A: 0, autocon_B: 0, autocon: 0,
               emocion_A:0, emocion_B: 0, emocion: 0,
               motivacion_A:0, motivacion_B: 0, motivacion: 0,
               relacionarse_A: 0, relacionarse_B: 0, relacionarse: 0,
               asesoria_A: 0, asesoria_B: 0, asesoria: 0,
          },
          //* Variables para un nuevo caso o el caso concurrente en la lista de casos. Funcionará para ON-LINE y OFF-LINE */
          st_ev10: {
               depto: "Guatemala",
               empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
               fecha: "16/01/2019", sexo: "",
               empezo: "10am", termino: "12am",
               pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
               pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
               pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
               pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
               pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, pg046: 0, pg047: 0, pg048: 0, pg049: 0, pg050: 0,
               pg051: 0, pg052: 0, pg053: 0, pg054: 0, pg055: 0, pg056: 0, pg057: 0, pg058: 0, pg059: 0, pg060: 0,
               pg061: 0, pg062: 0, pg063: 0, pg064: 0, pg065: 0, pg066: 0, pg067: 0, pg068: 0, pg069: 0, pg070: 0,
               pg071: 0, pg072: 0, pg073: 0, pg074: 0, pg075: 0, pg076: 0, pg077: 0, pg078: 0, pg079: 0, pg080: 0,
               pg081: 0, pg082: 0, pg083: 0, pg084: 0, pg085: 0, pg086: 0, pg087: 0, 
          },
          st_ev12: {
               depto: "Guatemala",
               empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
               fecha: "16/01/2019", sexo: "",
               empezo: "10am", termino: "12am",
               pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
               pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
               pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
               pg031: "", pg032: "", pg033: "", pg034: "", pg035: "", pg036: "", pg037: "", pg038: "", pg039: "", pg040: "",
               pg041: "", pg042: "", pg043: "", pg044: "", pg045: "", pg046: "", pg047: "", pg048: "", pg049: "", pg050: "",
               pg051: "", pg052: "", pg053: "", pg054: "", pg055: "", pg056: "", pg057: "", pg058: "", pg059: "", pg060: "",
               pg061: "", pg062: "", pg063: "", pg064: "", pg065: "", pg066: "", pg067: "", pg068: "", pg069: "", pg070: "",
               pg071: "", pg072: "", pg073: "", pg074: "", 
               pg074b: "", pg074c: "", pg074d: "", pg074e: "", pg074f: "", pg074g: "", pg074h: "", pg074i: "",     
               pg075: "", pg076: "", pg077: "", pg078: "", pg079: "", pg080: "",
               pg081: "", pg082: "", pg083: "", pg084: "", pg085: "", pg086: "", pg087: "", pg088: "", pg089: "", pg090: "",
               pg091: "", pg092: "", pg093: "", pg094: "", pg095: "", pg096: "", pg097: "", pg098: "", pg099: "", pg100: "",
               pg101: "", pg102: "", pg103: "", pg104: "", pg105: "", pg106: "", pg107: "", pg108: "", pg109: "", pg110: "",
               pg111: "", pg112: "", pg113: "", pg114: "", pg115: "", pg116: "", pg117: "", pg118: "", pg119: "", pg120: "",
               pg121: "", pg122: "", pg123: "", pg124: "", pg125: "", pg126: "", pg127: "", pg128: "", pg129: "", pg130: "",
               pg131: "", pg132: "", pg133: "", pg134: "", pg135: "", pg136: "", pg137: "", pg138: "", pg139: "", pg140: "",
               pg141: "", pg142: "", pg143: "", pg144: "", pg145: "", pg146: "", pg147: "", pg148: "", pg149: "", pg150: "",
               pg151: "", pg152: "", pg153: "", pg154: "", pg155: "", pg156: "", pg157: "", pg158: "", pg159: "", pg160: "",
               pg161: "", pg162: "", pg163: "", pg164: "", pg165: "", pg166: "", pg167: "", pg168: "", pg169: "", pg170: "",
               pg171: "", pg172: "", pg173: "", pg174: "", pg175: "", pg176: "", pg177: "", pg178: "", pg179: "", pg180: "",
               pg181: "", pg182: "", pg183: "", pg184: "", pg185: "", pg186: "", pg187: "", pg188: "", pg189: "", pg190: "",
               pg191: "", pg192: "", pg193: "", pg194: "", pg195: "", pg196: "", pg197: "", pg198: "", pg199: "", pg200: "",
               pg201: "", pg202: "", pg203: "", pg204: "", pg205: "", pg206: "", pg207: "", pg208: "", pg209: "", pg210: "",
               pg211: "", pg212: "", pg213: "", pg214: "", pg215: "", pg216: "", pg217: "", pg218: "", pg219: "", pg220: "",
               pg221: "", pg222: "", pg223: "", pg224: "", pg225: "", pg226: "", pg227: "", pg228: "", pg229: "", pg230: "",
               pg231: "", pg232: "", pg233: "", pg234: "", pg235: "", pg236: "", pg237: "", pg238: "", pg239: "", pg240: "",
               pg241: "", pg242: "", pg243: "", pg244: "", pg245: "", pg246: "", pg247: "", pg248: "", pg249: "", pg250: "",
               pg251: "", pg252: "", pg253: "", pg254: "", pg255: "", pg256: "", pg257: "", pg258: "", pg259: "", pg260: "",
          },
          st_rs12: {
               grupo1: 0, grupo2: 0, grupo3: 0, grupo4: 0,
               grupo5: 0, grupo6: 0, grupo7: 0, grupo8: 0,
               grupo9: 0, grupo10: 0, grupo11: 0, grupo12: 0, 
               grupo13: 0, grupo14: 0, grupo15: 0, grupo16: 0, 
               grupo17: 0, grupo18: 0, grupo19: 0, grupo20: 0, 
               grupo21: 0,
               grupoCol: 0,
          },

          st_rs10: {
               grupo1: 0, grupo2: 0, grupo3: 0, grupo4: 0,
               grupo5: 0, grupo6: 0, grupo7: 0, grupo8: 0,
               grupoR: 0, grupoA: 0, grupoCol: 0,
          },
          st_ev11: {
               depto: "Guatemala",
               empresa: "Empresa Ejemplo", nombre: "Participante Ejemplo",
               fecha: "16/01/2019", sexo: "",
               empezo: "10am", termino: "12am",
               pg001: "", pg002: "", pg003: "", pg004: "", pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
               pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
               pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
               pg02a: "", pg017a: "", pg018a: "", pg019a: "",
          },
          st_rs11: {

          },
          st_urlfoto: "", st_urlcv: "",
     },
     getters: getters,
     mutations: mutations, // mutations
});


// WEBPACK FOOTER //
// ./src/store/store.js